export enum NightTrainCategory {
    NIGHTJET = "NJ",
    EURONIGHT = "EN",
}

export function getNightTrainCategoryFromString(categoryString: string): NightTrainCategory {
    switch (categoryString) {
        case "NJ":
            return NightTrainCategory.NIGHTJET;
        case "EN":
            return NightTrainCategory.EURONIGHT;
        default:
            throw new Error(`There is no night train category with abbreviation ${categoryString}.`);
    }
}
